import React from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import TeamIcon from '@mui/icons-material/GroupsOutlined';

import { TeamsTableContainer } from '../../components/teams';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors } from '../../actions/adminActions';

import './admin.scss';

const TeamsPage = ({ teams, countries, users, procedures }) => {
  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Teams' number={teams?.length} icon={<TeamIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Teams' number={teams?.length} icon={<TeamIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Teams' number={teams?.length} icon={<TeamIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <TeamsTableContainer
        teams={teams}
        countries={countries}
        users={users}
        procedures={procedures}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  teams: state.teams.list,
  countries: state.countries.list,
  users: state.users.list,
  procedures: state.procedures.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamsPage);
